<template>
  <div class="marketing-automation-form-panel-email-section-counter-time-hour">
    <div class="marketing-automation-form-panel-email-section-counter-time-hour-input"
         :class="{ 'marketing-automation-form-panel-email-section-counter-time-hour-input_open' : isOpen}">
      <p class="marketing-automation-form-panel-email-section-counter-time-hour-input-label">{{$t('message.automation.message.sendAt')}}</p>
      <app-hour-picker :value="value"
                       class="marketing-automation-form-panel-email-section-counter-time-hour-input-picker"
                       datalabel="00:00"
                       :hide-details="true"
                       center
                       @input="emitInput"></app-hour-picker>
    </div>

    <app-button class="text-primary"
                :label="toggleLabel"
                :icon="toggleIcon"
                type="button"
                flat
                small
                underline
                primary
                @click="toggleIsOpen" />
  </div>
</template>

<script>
import AppHourPicker from "@components/HourPicker";
import AppButton from "@/components/generic/button/Button";

export default {
  components: {
    AppButton,
    AppHourPicker,
  },

  props: {
    value: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  created() {
    if (this.value) {
      this.isOpen = true;
    }
  },

  computed: {
    toggleLabel() {
      return this.isOpen
        ? this.$t('message.automation.message.removeSendingTime')
        : this.$t('message.automation.message.scheduleSendingTime');
    },
    toggleIcon() {
      return this.isOpen ? "minus-circle" : "plus-circle";
    },
  },

  methods: {
    emitInput(val) {
      console.log(val);
      this.$emit("input", val);
    },
    toggleIsOpen() {
      this.isOpen = !this.isOpen;

      if (!this.isOpen) {
        this.emitInput(null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-email-section-counter-time-hour {
  .marketing-automation-form-panel-email-section-counter-time-hour-input {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;

    .marketing-automation-form-panel-email-section-counter-time-hour-input-label {
      font-size: 14px;
      color: #707070;
      flex-shrink: 0;
      font-weight: 600;
      margin: 0;
    }

    .marketing-automation-form-panel-email-section-counter-time-hour-input-picker {
      display: flex;
      align-items: center;
      border: 1px solid #d6d6d6;
      padding: 5px !important;
      flex: 0 0 70px;
    }

    &.marketing-automation-form-panel-email-section-counter-time-hour-input_open {
      max-height: 100px;
    }
  }
}
</style>
